import { EnterpriseScopeCounterDiscriminator } from '@mews-commander/data-access';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { addAccountingCounter, addBillCounter, NonSystemCounterType } from '../actions';
import { CREATE_COUNTER_DIALOG } from '../constants';
import { CounterDialog } from './CounterDialog';
import { CounterFormValues } from './CounterForm/formMapping';

interface CreateCounterDialogProps {
    type: Exclude<NonSystemCounterType, EnterpriseScopeCounterDiscriminator.CreditNoteBillCounter>;
}

export const CreateCounterDialog = ({ type }: CreateCounterDialogProps) => {
    const dispatch = useCommanderThunkDispatch();

    const onSubmit = async (values: CounterFormValues) => {
        if (type === EnterpriseScopeCounterDiscriminator.BillCounter) {
            await dispatch(addBillCounter(values));
        } else {
            await dispatch(addAccountingCounter(values, type));
        }
    };

    return <CounterDialog onSubmit={onSubmit} name={CREATE_COUNTER_DIALOG} />;
};
